export default {
  contactType: {
    assistanceProvider: 'ASSISTANCEPROVIDER',
    auftragsauLoser: 'AUFTRAGSAUSLÖSER',
    conseqDamage: 'CONSEQDAMAGE',
    contact: 'CONTACT',
    contractor: 'CONTRACTOR',
    customer: 'CUSTOMER',
    customerRef: 'CUSTOMER_REF',
    einsatzort: 'EINSATZORT',
    extexpert: 'EXTEXPERT',
    insurance: 'INSURANCE',
    insuranceBroker: 'INSURANCEBROKER',
    internal: 'INTERNAL',
    keyCustomerContact: 'KEYCUSTOMERCONTACT',
    lossAdjuster: 'LOSSADJUSTER',
    maincontractor: 'MAINCONTRACTOR',
    makler: 'MAKLER',
    onSite: 'ONSITE',
    owner: 'OWNER',
    ownerCounterExpert: 'OWNERCOUNTEREXPERT',
    ownerSiteExpert: 'OWNERSEXPERT',
    payingCustomer: 'PAYING CUSTOMER',
    plumber: 'PLUMBER',
    policyHolder: 'POLICYHOLDER',
    primaryContact: 'PRIMARYCONTACT',
    primaerKontakt: 'PRIMÆRKONTAKT',
    projectManager: 'PROJMGR',
    propertyManager: 'PRPMGMT',
    renterCounterExpert: 'RENTERCOUNTEREXPERT',
    rentersExpert: 'RENTERSEXPERT',
    skadeledning: 'SKADELEDNING',
    supplier: 'SUPPLIER',
    tenant: 'TENANT',
    workSite: 'WORKSITE'
  },
  eventTypes: {
    changedPlannedStartTime: 'ChangedPlannedStartTime',
    changedTechnician: 'ChangedTechnician'
  },
  internalEventIds: {
    mainKeyAccess: 'INTERNAL_MAINKEYACCESS',
    prelCalcApproved: 'INTERNAL_PRELCALCAPPROVED',
    calcApproved: 'INTERNAL_MAINKEYACCESS',
    measureWorkStarted: 'INTERNAL_MEASUREWORKSTARTED'
  },
  eventCodes: {
    open: 'OPEN',
    completed: 'COMPLT',
    closed: 'CLOSED'
  },
  fsmRequestStatus: {
    open: 'OPEN',
    inProcess: 'IN PROCESS',
    pendComp: 'PENDCOMP',
    closed: 'CLOSED',
    hold: 'HOLD',
    complete: 'COMPLETE',
    pendQuote: 'PENDQUOTE',
    canceled: 'CANCELED',
    poWait: 'POWAIT'
  },
  apps10RequestStatus: {
    faultReport: 'FAULTREPORT',
    workRequest: 'WORKREQUEST',
    observed: 'OBSERVED',
    underPreparation: 'UNDERPREPARATION',
    prepared: 'PREPARED',
    released: 'RELEASED',
    started: 'STARTED',
    workDone: 'WORKDONE',
    reported: 'REPORTED',
    finished: 'FINISHED',
    canceled: 'CANCELED'
  },
  backendSystem: {
    'fsm': 'FSM',
    'apps10': 'IFS10'
  },
  stepnames: {
    prelCalcAvailable: 'KALKYLSTATUS1',
    finalCalcAvailable: 'KALKYLSTATUS2'
  },
  stepIds: {
    prelCalcAvailable: 375,
    finalCalcAvailable: 376
  },
  addressType: {
    default: 'DEFAULT',
    billTo: 'BILL TO'
  },
  customClaims: {
    errandId: 'errand_id',
    channel: 'channel',
    accessGroup: 'access_group',
    isoCode: 'iso_code',
    country: 'country',
    companyKey: 'company_key',
    displayName: 'display_name',
    phone: 'phone',
    irrevocable: 'irrevocable',
    readOnly: 'readonly',
    isSparkProUser: 'is_spark_pro_user'
  },
  roles: {
    businessPartner: 'BusinessPartner',
    endCustomer: 'EndCustomer',
    globalAdmin: 'GlobalAdmin',
    contentManager: 'ContentManager'
  },
  textLineCode: {
    sparkWorkInstruction: 'SPARKWORKINSTR',
    sparkOrderNote: 'SPARKORDERNOTE',
    cust: 'CUST'
  },
  taskStatus: {
    completed: 'COMPLETED',
    enroute: 'ENROUTE',
    compTask: 'COMPTASK',
    open: 'OPEN',
    closed: 'CLOSED',
    assigned: 'ASSIGNED',
    dispatched: 'DISPATCHED',
    hold: 'HOLD',
    arrived: 'ARRIVED',
    inspection: 'INSPECTION',
    accepted: 'ACCEPTED',
    unassigned: 'UNASSIGNED',
    pendComp: 'PENDCOMP',
    cancelled: 'CANCELLED',
    inProcess: 'IN PROCESS',
    rejected: 'REJECTED'
  }
}
